import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from "react-router-dom";
import { DataTable } from '../../../components/DataTable/DataTable';
import { useDataTable } from '../../../components/DataTable/useDataTable';
import ACCESS from '../../../ACCESS.js';
import Dialog from '../../../components/dialog/Dialog';
import { ZonaKmService } from '../../../services/ZonaKmService';

const ZonasKm = () => {
    const history = useHistory();
    const tableState = useDataTable({ initialLimit: 15 });
    
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    
    // Dialog state for deletion
    const [dialog, setDialog] = useState({ show: false, title: '', options: ['Sí', 'No'], row: null });

    const fetchData = useCallback(async () => {
        setLoading(true);
        const rows = await ZonaKmService.obtenerLista(
            tableState.page,
            tableState.limit,
            tableState.filters,
            tableState.orderBy,
            tableState.order
        );
        setData(rows);
        setLoading(false);
    }, [tableState.page, tableState.limit, tableState.filters, tableState.orderBy, tableState.order]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const hasMore = data.length === tableState.limit; 

    // Column definitions
    const columns = [
        { 
            id: 'letra', 
            label: 'Zona',
            render: (row) => (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-blue-100 text-blue-800">
                    {row.letra}
                </span>
            )
        },
        { 
            id: 'desde', 
            label: 'KM Desde',
            render: (row) => `${Number(row.desde || 0).toFixed(2)} km`
        },
        { 
            id: 'hasta', 
            label: 'KM Hasta',
            render: (row) => `${Number(row.hasta || 0).toFixed(2)} km`
        },
        { 
            id: 'tiempo_horas', 
            label: 'Tiempo Entrega',
            render: (row) => (
                <span className="font-bold text-gray-800">
                    {Number(row.tiempo_horas || 0).toFixed(2)} hrs
                </span>
            )
        },
        { 
            id: 'sucursal_nombre', 
            label: 'Sucursal',
            render: (row) => row.sucursal_nombre || <span className="text-gray-400 italic">General (Todas)</span>
        },
        { 
            id: 'es_resto', 
            label: 'Fallback / Resto',
            render: (row) => (
                row.es_resto ? (
                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold bg-amber-100 text-amber-800">
                        Sí (Resto)
                    </span>
                ) : (
                    <span className="text-gray-400 text-xs">No</span>
                )
            )
        },
        { 
            id: 'activo', 
            label: 'Estatus',
            render: (row) => (
                row.activo ? (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800">
                        Activo
                    </span>
                ) : (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                        Inactivo
                    </span>
                )
            )
        },
    ];

    const handleDeleteClick = (row) => {
        setDialog({
            show: true,
            title: `¿Borrar la configuración de la Zona ${row.letra}?`,
            options: ['Sí', 'No'],
            row: row,
        });
    };

    const handleDialogClose = async (op) => {
        const rowToDelete = dialog.row;
        setDialog({ show: false, title: '', options: [], row: null });
        
        if (op === 1 && rowToDelete) {
            setLoading(true);
            const success = await ZonaKmService.eliminar(rowToDelete);
            if (success) {
                fetchData();
            } else {
                setLoading(false);
            }
        }
    };

    const actions = [
        {
            id: 'edit',
            icon: 'edit',
            access: ACCESS.CATALOGO_ZONAS_KM.EDITAR_CATALOGO,
            onClick: (actionId, row) => history.push(`/Catalogo/ZonaKm/${row.id}`)
        },
        {
            id: 'delete',
            icon: 'delete',
            access: ACCESS.CATALOGO_ZONAS_KM.ELIMINAR_CATALOGO,
            onClick: (actionId, row) => handleDeleteClick(row)
        }
    ];

    return (
        <div className="w-full">
            <DataTable
                columns={columns}
                data={data}
                loading={loading}
                actions={actions}
                hasMore={hasMore}
                page={tableState.page}
                limit={tableState.limit}
                onPageChange={tableState.handlePageChange}
                onLimitChange={tableState.handleLimitChange}
                orderBy={tableState.orderBy}
                order={tableState.order}
                onSort={tableState.handleSort}
                filters={tableState.filters}
                onFilterChange={tableState.handleFilterChange}
                onRowClick={(row) => history.push(`/Catalogo/ZonaKm/${row.id}`)}
            />
            <Dialog dialog={dialog} onClose={handleDialogClose} />
        </div>
    );
};

export default ZonasKm;
